<template>
  <div class="container">
    <div class="find_wrap">
      <div class="tab_area">
        <div id="" class="">STEP 01. 아이디 찾기</div>
        <div id="" class="on">STEP 02. 아이디 확인</div>
      </div>
      <div class="find_form find_form_id">
        <div class="find_complete_title">
          입력하신 정보와 일치하는 결과입니다.
        </div>
        <div class="find_complete_content">
          <div class="find">{{ getId }}</div>
          <div class="dt">
            <ul>
              <li class="bold">가입일</li>
              <li>|</li>
              <li>{{ innerDate }}</li>
            </ul>
          </div>
          <div class="form_area">
            <div class="btn_area">
              <a
                href="#"
                class="btn_orange btn_cancel"
                @click.prevent="clearLocalStorage('/find_pw')"
                >비밀번호 찾기</a
              >
              <a
                href="#"
                class="btn_orange"
                @click.prevent="clearLocalStorage('/login')"
                >로그인</a
              >
              <!-- <a href="/find_pw" class="btn_orange btn_cancel">비밀번호 찾기</a>
              <a href="/login" class="btn_orange">로그인</a> -->
            </div>
          </div>
          <div class="Modals">
            <ModalAlert
              :alert-msg="errMsg"
              :is-open="errStatus"
              @update:is-open="updateStatus"
            ></ModalAlert>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import ModalAlert from '../components/ModalAlert.vue'
// import Cookies from "vue-cookies";

export default {
  name: 'FindIDNoneMaskingView',
  components: {
    ModalAlert,
  },
  setup() {
    const test = ref('')

    const getId = ref(localStorage.getItem('originalID'))
    const innerDate = ref(localStorage.getItem('joinDate'))
    // const getId = ref(Cookies.get('originalID'));
    // const innerDate = ref(Cookies.get('joinDate'));

    const clearLocalStorage = (path) => {
      // localStorage 항목들 삭제
      localStorage.removeItem('originalID')
      localStorage.removeItem('joinDate')
      localStorage.removeItem('userName')
      localStorage.removeItem('firstStap')

      // 페이지 이동
      window.location.href = path
    }
    onMounted(() => {})
    return {
      test,
      getId,
      innerDate,
      clearLocalStorage,
    }
  },
}
</script>
